/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import {
  Button,
  Grid,
  Link,
  TextField,
} from '@material-ui/core';
import {
  signIn,
  selectIsPending,
  setIsForgotPassword,
  setIsUserRegistration,
} from '../../store/authSlice';
import {
  isRequired,
  validateField,
  validateForm,
} from '../../helpers/validation';
import PasswordField from '../common/PasswordField';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignInForm() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const isPending = useSelector(selectIsPending);
  const [formErrors, setFormErrors] = useState({});
  const [formValues, setFormValues] = useState({
    username: '',
    password: '',
  });

  const formRules = {
    username: [isRequired],
    password: [isRequired],
  };

  const attemptSignIn = (event) => {
    event.preventDefault();
    if (validateForm(formRules, formValues, formErrors, setFormErrors)) {
      dispatch(signIn({ username: formValues.username.trim(), password: formValues.password }));
    }
  };

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const handleBlur = (event) => {
    validateField(formRules, formErrors, setFormErrors, event.target.name, event.target.value);
  };

  const handleForgotPasswordClick = (event) => {
    event.preventDefault();
    dispatch(setIsForgotPassword(true));
  };

  const handleSignUpClick = (event) => {
    event.preventDefault();
    dispatch(setIsUserRegistration(true));
  };

  return (
    <form className={classes.form} noValidate>
      <TextField
        variant="outlined"
        margin="normal"
        id="username"
        label="Username"
        name="username"
        autoComplete="username"
        value={formValues.username}
        error={!!formErrors.username}
        helperText={formErrors.username}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <PasswordField
        variant="outlined"
        margin="normal"
        name="password"
        label="Password"
        id="password"
        autoComplete="current-password"
        value={formValues.password}
        error={!!formErrors.password}
        helperText={formErrors.password}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={isPending}
        fullWidth
        required
      />
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
        onClick={attemptSignIn}
        disabled={isPending}
      >
        Sign In
      </Button>
      <Grid container>
        <Grid item xs>
          <Link component="button" onClick={handleForgotPasswordClick} variant="body2">
            Forgot password?
          </Link>
        </Grid>
        <Grid item>
          <Link component="button" onClick={handleSignUpClick} variant="body2">
            Don&apos;t have an account? Sign up
          </Link>
        </Grid>
      </Grid>
    </form>
  );
}
